import moment from 'moment';
import { isRequired } from './isRequired';
import { FORMAT_DATE_FR } from '../date';
import { and, isNil } from 'ramda';

export const dateIsCorrectlyBefore = (dateToCompare, message, mandatory = true) => {
  if (isNil(dateToCompare)) {
    return isRequired;
  }
  return {
    ...(mandatory ? { required: isRequired } : null),
    validate: (date) =>
      moment(date).isBefore(dateToCompare) ||
      message ||
      'La date de naissance est invalide. L’âge à la date d’effet du contrat doit être au minimum de 18 ans'
  };
};

export const dateIsCorrectlyAfter = (dateToCompare, message, mandatory = true) => {
  if (isNil(dateToCompare)) {
    return isRequired;
  }

  return {
    ...(mandatory ? { required: isRequired } : null),
    validate: (date) =>
      moment(date).isSameOrAfter(dateToCompare) ||
      message ||
      'La date de naissance est invalide. L’âge à la date d’effet du contrat doit être compris entre 0 et 28 ans'
  };
};

export const dateIsBetween = (minDate, maxDate, message, mandatory = true) => {
  const dateIsCorrect = (date) => moment(date).isBetween(minDate, maxDate, {}, []);

  return {
    ...(mandatory ? { required: isRequired } : null),
    validate: (date) =>
      dateIsCorrect(date) ||
      message ||
      `La date doit être comprise entre le ${minDate.format(FORMAT_DATE_FR)} et le ${maxDate.format(FORMAT_DATE_FR)}`
  };
};

export const dateHasConstraints = (
  minDate,
  maxDate,
  messageMin,
  messageMax,
  messageAll,
  mandatory = true
) => {
  if (and(minDate, maxDate)) {
    return dateIsBetween(minDate, maxDate, messageAll, mandatory);
  } else if (minDate) {
    return dateIsCorrectlyAfter(minDate, messageMax, mandatory);
  } else if (maxDate) {
    return dateIsCorrectlyBefore(maxDate, messageMin, mandatory);
  }
};
